<script setup>
import { isEmpty } from 'lodash'

import FormFieldNext from '@/components/form/FormFieldNext'
import AppInput from '@/components/ui/AppInput/AppInput'

defineOptions({
  name: 'CopyLinksList'
})

defineProps({
  linksList: {
    type: Array,
    default: () => []
  }
})
</script>

<template>
  <div v-if="!isEmpty(linksList)" class="cll-List">
    <slot name="before-list" />
    <FormFieldNext v-for="link in linksList" :key="link.id" :label="link.label">
      <AppInput :model-value="link.path" copyable readonly size="xlg" style-type="primary" />
    </FormFieldNext>
  </div>
</template>

<style lang="scss" scoped>
.cll-List {
  margin-top: 24px;
  display: grid;
  gap: 24px;
}
</style>
